import numeral from 'numeral'

export default function (value) {
	value = value.replace(/[^\d]/g,'')
	return value ? numeral(value).format('0,0') : ''
} 